export default "__VITE_ASSET__DBIAQGuB__"